import { createGlobalStyle } from 'styled-components'
import { TRANSITION_ANIMATION_DURATION } from 'Lib/Constants'
import { ButtonFooter } from 'Containers/OnboardingSteps.container'
import { ReinforcementOverlayBox } from 'Components/ReinforcementScreen/ReinforcementOverlay'
import { ReinforcementContainer } from 'Components/ReinforcementScreen/ReinforcementMain'
import { ModalSheetContent, ModalSheetContainer } from 'Components/ModalSheet'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: Fira Sans, sans-serif;
    color: ${props => props.theme.colors.text};
  }

  :root {
    // This values are being overridden depending whether user going back or further in RootRouter.
    --enter-translate: 100%;
    --exit-translate: -100%;
  }

  #root {
    // Sets the page's minimum height to be as large as the user's viewport (excluding the browser's UI)
    @supports(min-height: 100dvh) {
      min-height: calc(100dvh - 16px);
    }
    white-space: pre-line;
  }

  .step-transition-enter {
    opacity: 0;
    transform: translateX(var(--enter-translate));
  }

  .step-transition-enter-active {
    opacity: 1;
    transform: translateX(0);
    transition: opacity ${TRANSITION_ANIMATION_DURATION}ms, transform ${TRANSITION_ANIMATION_DURATION}ms;
  }

  /* Reset the button's state so it reanimates when another step shows up with the same Continue button */
  .step-transition-enter-active ${ButtonFooter}, .no-transition-enter-active ${ButtonFooter} {
    transform: translateY(100%);
    opacity: 0;
    transition: none;
  }

  .step-transition-enter-done,
  .step-transition-exit-done {
    position: static;
  }

  .step-transition-exit {
    opacity: 1;
    transform: translateX(0);
  }

  .step-transition-exit-active {
    position: absolute;
    opacity: 0;
    top: 0px;
    width: 100%;
    position: absolute;
    transform: translateX(var(--exit-translate));
    transition: opacity ${TRANSITION_ANIMATION_DURATION}ms, transform ${TRANSITION_ANIMATION_DURATION}ms;

    @media screen and (max-width: 576px) {
      width: calc(100% - 16px);
    }
  }

  .no-transition-enter {
    opacity: 0;
  }

  .no-transition-enter-active {
    opacity: 1;
  }

  .no-transition-exit {
    opacity: 1
  }

  .no-transition-exit-active {
    opacity: 0
  }

  .info-transition-exit {
    pointer-events: none;
  }

  .info-transition-enter ${ReinforcementContainer} {
    opacity: 0;
  }

  .info-transition-enter-active ${ReinforcementContainer} {
    opacity: 1;
    transition: opacity 300ms, transform 300ms;
  }

  .info-transition-exit ${ReinforcementContainer},
  .info-transition-enter-done ${ReinforcementContainer} {
    opacity: 1;
  }

  .info-transition-enter-done ${ReinforcementContainer} {
    overflow: auto;
  }

  .info-transition-exit-active ${ReinforcementContainer} {
    opacity: 0;
    transition: opacity 300ms, transform 300ms;
  }

  .info-transition-enter ${ReinforcementOverlayBox} {
    opacity: 0;
    transform: translateY(200px);
  }

  .info-transition-enter-active ${ReinforcementOverlayBox},
  .info-transition-enter-done ${ReinforcementOverlayBox} {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 600ms ease, transform 600ms ease;
  }

  .info-transition-exit-active ${ReinforcementOverlayBox},
  .info-transition-exit-done ${ReinforcementOverlayBox} {
    opacity: 0;
    transform: translateY(200px);
    transition: opacity 600ms ease, transform 600ms ease;
  }

  .modal-sheet-transition-enter-active ${ModalSheetContainer},
  .modal-sheet-transition-exit-active ${ModalSheetContainer},
  .modal-sheet-transition-enter-active ${ModalSheetContent},
  .modal-sheet-transition-exit-active ${ModalSheetContent},
  .modal-sheet-transition-enter-done ${ModalSheetContent} {
    transition: background-color 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.6s ease-in-out;
  }

  .modal-sheet-transition-enter ${ModalSheetContainer},
  .modal-sheet-transition-exit-active ${ModalSheetContainer} {
    background-color: rgba(41, 41, 41, 0);
  }

  .modal-sheet-transition-enter-active ${ModalSheetContainer},
  .modal-sheet-transition-enter-done ${ModalSheetContainer} {
    background-color: rgba(41, 41, 41, 0.4);
  }

  .modal-sheet-transition-enter ${ModalSheetContent},
  .modal-sheet-transition-exit-active ${ModalSheetContent},
  .modal-sheet-transition-exit-done ${ModalSheetContent} {
    opacity: 0;
    transform: translateY(100%);
  }

  .modal-sheet-transition-enter-active ${ModalSheetContent},
  .modal-sheet-transition-enter-done ${ModalSheetContent} {
    opacity: 1;
    transform: translateY(0%);
  }
`
export default GlobalStyle
